var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6859 18.222C13.0879 18.3 13.4939 18.341 13.9039 18.345C14.9353 18.3455 15.955 18.1273 16.8959 17.705L19.9909 18.16C20.1357 18.1611 20.279 18.1316 20.4116 18.0735C20.5442 18.0154 20.663 17.9301 20.7604 17.823C20.8578 17.7159 20.9315 17.5895 20.9767 17.452C21.0219 17.3145 21.0377 17.169 21.0229 17.025L20.6509 13.899C21.0494 12.9843 21.2534 11.9968 21.2499 10.999C21.2473 10.0388 21.0554 9.0886 20.6852 8.20265C20.3149 7.31671 19.7736 6.51246 19.0923 5.83592C18.4109 5.15938 17.6028 4.62383 16.7143 4.2599C15.8257 3.89598 14.8741 3.71083 13.9139 3.71504C12.2643 3.71482 10.6632 4.27375 9.37209 5.30061C8.08097 6.32748 7.17602 7.76164 6.80493 9.36904",
    stroke: "#9747FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.904 14.745C13.8971 16.0074 13.4684 17.2313 12.686 18.222C12.1568 18.8705 11.4892 19.3923 10.7322 19.7493C9.97521 20.1062 9.14791 20.2893 8.31096 20.285C7.52159 20.2804 6.74179 20.1118 6.02096 19.79L3.70996 20.203C3.59385 20.2159 3.47634 20.2016 3.36671 20.1612C3.25707 20.1209 3.15831 20.0556 3.07821 19.9706C2.99812 19.8855 2.93888 19.783 2.90517 19.6712C2.87146 19.5593 2.8642 19.4412 2.88396 19.326L3.20396 16.963C2.90032 16.2629 2.74571 15.5072 2.74996 14.744C2.74856 13.5289 3.14384 12.3466 3.87573 11.3766C4.60762 10.4067 5.63612 9.70213 6.80496 9.37004C7.29714 9.22319 7.80835 9.15006 8.32196 9.15304C9.80366 9.15516 11.2239 9.74545 12.2706 10.7942C13.3173 11.8429 13.9048 13.2643 13.904 14.746",
    stroke: "#9747FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasual);
export default __webpack_public_path__ + "static/media/casual.2ed6921287990177d16ef5716a34c8f6.svg";
export { ForwardRef as ReactComponent };